
import CardPropertyObjectCustom from '../../components/Card/CardPropertyObjectCustom.vue'

export default {
  extends: CardPropertyObjectCustom,
  created: function () {
    this.componentProps.objectsMapper = workArea => {
      let disabled = false
      if (this.object.mainWorkAreaSchedule && this.object.mainWorkAreaSchedule.workAreas) {
        this.object.mainWorkAreaSchedule.workAreas.forEach((workAreaScheduleKeys, index) => {
          const now = new Date().getTime()
          if (workAreaScheduleKeys.includes(workArea.key)) {
            if (this.object.mainWorkAreaSchedule.endTime && this.object.mainWorkAreaSchedule.endTime[index] && now < this.object.mainWorkAreaSchedule.endTime[index]) {
              disabled = true
            }
          }
        })
      }
      return {
        ...workArea,
        _disabled: disabled,
        _reasonDisabled: 'Сотрудник будет переведён в этот отдел'
      }
    }
  }
}
